export default __webpack_public_path__ + "static/media/camera-on.20bce5fd.svg";